import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
import TextField from "@mui/material/TextField";
import Link from "next/link";
import React from "react";
import { Span } from "src/lib/components/salify-next-layout/default/components/Typography";
import {
  FlexBetween,
  FlexBox,
} from "src/lib/components/salify-next-layout/default/components/flex-box"; // DUMMY CUSTOM DATA
import useCart from "src/lib/components/salify-next-layout/default/hooks/useCart"; // GLOBAL CUSTOM COMPONENTS
import { formatMoney } from "src/lib/utils";
import SalifyFallback from "../../../salify-fallback/default";
import { useCardSectionContext } from "../context";

const CartArticleRightCheckout = (props: React.PropsWithChildren<{ nextUrl: string }>) => {
  const { state } = useCart();
  const { registerControl } = useCardSectionContext();
  const getTotalPrice = () =>
    state.cart.reduce((acc, item) => acc + item.product.salePrice * item.quantity, 0);

  return (
    <Card sx={{ padding: 3 }}>
      <FlexBetween mb={2}>
        <Span color="grey.600">
          <SalifyFallback.Label path="Total" default="Tổng:" />
        </Span>

        <Span fontSize={18} fontWeight={600} lineHeight="1">
          {formatMoney(getTotalPrice())}
        </Span>
      </FlexBetween>

      <Divider sx={{ mb: 2 }} />

      <FlexBox alignItems="center" columnGap={1} mb={2}>
        <Span fontWeight="600">
          <SalifyFallback.Label path="Additional Comments" default="Ghí chú đơn hàng" />
        </Span>

        <Span
          p="6px 10px"
          fontSize={12}
          lineHeight="1"
          borderRadius="3px"
          color="primary.main"
          bgcolor="primary.light"
        >
          <SalifyFallback.Label path="note" default="Ghí chú" />
        </Span>
      </FlexBox>

      <TextField
        variant="outlined"
        rows={6}
        fullWidth
        multiline
        {...registerControl("description")}
      />

      <Divider sx={{ mb: 2 }} />

      {/* <Span fontWeight={600} mb={2} display="block">
        <SalifyFallback.Label path="Shipping Estimates" default="Ước tính phí vận chuyển" />
      </Span>

      <Box display="flex" flexDirection="column" gap={2}>
        <CartBazaarLocationControls />
      </Box>

      <Button
        variant="outlined"
        color="primary"
        fullWidth
        sx={{
          my: 2,
        }}
      >
        <SalifyFallback.Label path="Calculate Shipping" default="Tính toán phí vận chuyển" />
      </Button> */}

      <Button
        fullWidth
        color="primary"
        href={props.nextUrl}
        variant="contained"
        LinkComponent={Link}
      >
        <SalifyFallback.Label path="Checkout Now" default="Tiếp tục" />
      </Button>
    </Card>
  );
};

export default CartArticleRightCheckout;
